

import './is_site.js'

import Vue from 'vue'

import Router from './router.js'
import App from './App.vue'

import Vuex from 'vuex'
Vue.use(Vuex)

import store from './store/store.js'
import storePlugin from './store/storePlugin'
Vue.use(storePlugin)


//import helpersPlugin from './helpersPlugin';

import Toasted from 'vue-toasted'
import svgicon from 'vue-svgicon'
//import Multiselect from 'vue-multiselect'

Vue.config.productionTip = false


import VueAutosuggest from 'vue-autosuggest'
Vue.use(VueAutosuggest)

import VoerroTagsInput from '@voerro/vue-tagsinput'
Vue.component('tags-input', VoerroTagsInput)


import vbclass from 'vue-body-class'
Vue.use( vbclass, Router )

// google maps api key
// AIzaSyAsL9U37Dtj1E4w-6zwZZFmcDC4j_fSV0Q


import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.use(Toasted)

Vue.use(svgicon, {
  tagName: 'svgicon'
})



window.env = 'live'
if ( window.location.href.indexOf('localhost:') > 0 )      window.env = 'local'
if ( window.location.href.indexOf('.test') > 0 )           window.env = 'local'

if( window.env == 'local' )   window.baseUrl = 'http://localhost:3000/'
if( window.env == 'live' )    window.baseUrl = 'https://scoopmodels.com/'

window.apiUrl = window.baseUrl + 'api/'


//Vue.component('multiselect', Multiselect)


// event bus for Non-Parent-Child-Communication
window.eventBus = new Vue()

//window.firebaseApp = firebase.initializeApp(firebaseConfig)
//const db = firebaseApp.database()
//console.log( db.ref('clients') )


/* eslint-disable no-new */
window.app = new Vue({
  el: '#app',
  router: Router,
//  store,
  render: h => h(App)
})





// WEBPACK FOOTER //
// ./src/main.js